<template>
  <div class="">
    <div class="row" v-if="isAdmin">
      <div class="col-xs-12 col-sm-12 col-md-6">
        <coordinator-commission-report></coordinator-commission-report>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6">
        <monthly-breakdown-report></monthly-breakdown-report>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-6" v-if="isAdmin">
        <completed-jobs-report></completed-jobs-report>
      </div>

      <div class="col-xs-12 col-sm-12 col-md-6">
        <carrier-income-report></carrier-income-report>
      </div>
    </div>
    <div class="row" v-if="isAdmin">
      <div class="col-xs-12 col-sm-12 col-md-6">
        <system-users-report></system-users-report>
      </div>
    </div>
  </div>
</template>

<script>
  import CoordinatorCommissionReport from './CoordinatorCommissionReport'
  import CarrierIncomeReport from './CarrierIncomeReport'
  import SystemUsersReport from './SystemUsersReport'
  import MonthlyBreakdownReport from './MonthlyBreakdownReport'
  import CompletedJobsReport from './CompletedJobsReport'

  export default {
    components: {
      CoordinatorCommissionReport,
      CarrierIncomeReport,
      SystemUsersReport,
      MonthlyBreakdownReport,
      CompletedJobsReport
    },

    computed: {
      privateChannel () {
        return `${this.$user.privateChannel}.reports`
      },

      isAdmin () {
        return this.$user.isAdmin
      }
    },

    created () {
      // this.$echo.private(this.privateChannel).stopListening('ReportGenerated')

      this.$echo.private(this.privateChannel).listen('ReportGenerated', event => {
        const link = `${process.env.API_DOMAIN}/reports/${event.reportFileName}/download`

        this.$http.get('auth').then(response => {
          // update url with latest token
          window.location.href = `${link}?name=${event.reportDownloadName}&token=${response.data}`
        })
      })
    }
  }
</script>



// WEBPACK FOOTER //
// Reports.vue?95b64cd8